module.exports = __webpack_public_path__ + "static/img/dj1-4.01aec69.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/dj1-4.png
// module id = 790
// module chunks = 0